export * from './user-profile-rfid-tags-widget'
